(() => {
  if (window.__gemlayGiftBoxReady) return;
  window.__gemlayGiftBoxReady = true;
  const GIFT_IDS = [68032048955628,68032048988396,68032049021164,68032049053932,68032049086700];
  const giftSet = new Set(GIFT_IDS.map(String));
  const money = (c) => '₹' + (Number(c || 0) / 100).toLocaleString('en-IN', {maximumFractionDigits: 0});
  const rootUrl = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  const fetchCart = () => fetch(rootUrl + 'cart.js', {credentials:'same-origin'}).then(r => { if(!r.ok)throw new Error('Cart unavailable');return r.json(); });
  const nonGiftSubtotal = (cart) => cart.items.reduce((sum,i) => sum + (giftSet.has(String(i.variant_id)) ? 0 : i.final_line_price),0);
  const selectedProduct = (root) => {
    const form = document.querySelector('.gemlay-pdp product-form form');
    if(!form)return {price:0,quantity:1};
    const id = Number(form.querySelector('input[name="id"]')?.value || 0);
    const variants = JSON.parse(root.querySelector('.gemlay-gift-upsell__variants-json')?.textContent || '[]');
    const variant = variants.find(v => Number(v.id) === id);
    const quantity = Math.max(1,Number(document.querySelector('.gemlay-pdp input[name="quantity"]')?.value || 1));
    return {price:variant?.price || 0,quantity};
  };
  const refreshEstimate = (root) => {
    if(root.dataset.context!=='pdp')return;
    const selected=root.querySelector('.gemlay-gift-upsell__choice[data-variant-id="'+root.dataset.selectedId+'"]');
    const line=root.querySelector('.gemlay-gift-upsell__combined');
    if(!selected){line.hidden=true;return;}
    const p=selectedProduct(root);
    line.hidden=false;
    line.textContent='Jewellery + packaging: '+money(p.price*p.quantity+Number(selected.dataset.price||0))+' (excluding other cart items)';
  };
  const setSummary = (root) => {
    const picked=root.querySelector('.gemlay-gift-upsell__choice[data-variant-id="'+root.dataset.selectedId+'"]');
    root.querySelector('.gemlay-gift-upsell__check').checked=!!picked;
    root.querySelector('.gemlay-gift-upsell__summary').textContent=picked?(picked.dataset.name+' · '+money(picked.dataset.price)):'Classic ₹199 · Teddy ₹499';
    root.querySelector('.gemlay-gift-upsell__thumb').src = picked?.querySelector('img')?.src || 'https://cdn.shopify.com/s/files/1/0845/6758/9100/files/gemlay-gift-red-rose-individual.jpg?v=1793604415';
    refreshEstimate(root);
  };
  const eligibilityTotal = async (root) => {
    const c=await fetchCart();let subtotal=nonGiftSubtotal(c);
    if(root.dataset.context==='pdp'){const p=selectedProduct(root);subtotal+=p.price*p.quantity;}
    return subtotal;
  };
  const openPicker = (root) => {
    const overlay=root.querySelector('.gemlay-gift-upsell__overlay');
    overlay.hidden=false;
    document.body.style.overflow='hidden';
    root.querySelectorAll('.gemlay-gift-upsell__choice').forEach(c=>{
      c.disabled=false;
      c.title='';
      c.querySelector('small').textContent=money(c.dataset.price)+' · Optional add-on';
    });
    root.querySelector('.gemlay-gift-upsell__help').textContent='No minimum jewellery spend. Packaging is charged separately.';
    root.querySelector('.gemlay-gift-upsell__close').focus();
  };
  const closePicker=(root)=>{root.querySelector('.gemlay-gift-upsell__overlay').hidden=true;document.body.style.overflow='';setSummary(root);};
  const applyToCart=async(root,id)=>{
    root.classList.add('is-loading');
    try{
      const cart=await fetchCart();
      const updates={};
      for(const item of cart.items){if(giftSet.has(String(item.variant_id)))updates[String(item.variant_id)]=0;}
      if(id)updates[String(id)]=1;
      const drawer=document.querySelector('cart-drawer');
      const sections=drawer?.getSectionsToRender?.().map(s=>s.id)||['cart-drawer','cart-icon-bubble'];
      const response=await fetch(rootUrl+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates,sections,sections_url:window.location.pathname})});
      const data=await response.json();if(!response.ok||data.status)throw new Error(data.description||'Could not update packaging');
      root.dataset.selectedId=id||'';
      closePicker(root);
      if(root.dataset.context==='drawer'&&drawer?.renderContents&&data.sections){drawer.renderContents(data);}else{window.location.reload();}
    }catch(e){root.querySelector('.gemlay-gift-upsell__help').textContent=e.message||'Could not update gift box';root.querySelector('.gemlay-gift-upsell__overlay').hidden=false;}
    finally{root.classList.remove('is-loading');}
  };
  document.addEventListener('click', e => {
    const root=e.target.closest('.gemlay-gift-upsell');if(!root)return;
    if(e.target.closest('.gemlay-gift-upsell__edit')){e.preventDefault();openPicker(root);}
    else if(e.target.closest('.gemlay-gift-upsell__close')||e.target.classList.contains('gemlay-gift-upsell__overlay')){e.preventDefault();closePicker(root);}
    else {
      const choice=e.target.closest('.gemlay-gift-upsell__choice');
      if(choice){e.preventDefault();if(choice.disabled)return;const id=choice.dataset.variantId;
        if(root.dataset.context==='pdp'){root.dataset.selectedId=id;closePicker(root);}
        else applyToCart(root,id);
      }
    }
  });
  document.addEventListener('change', e => {
    const checkbox=e.target.closest('.gemlay-gift-upsell__check');
    if(checkbox){const root=checkbox.closest('.gemlay-gift-upsell');if(checkbox.checked){openPicker(root);}else if(root.dataset.context==='pdp'){root.dataset.selectedId='';closePicker(root);}else applyToCart(root,'');return;}
    if(e.target.matches('.gemlay-pdp input[name="quantity"],.gemlay-pdp input[name="id"]')){
      document.querySelectorAll('.gemlay-gift-upsell[data-context="pdp"]').forEach(refreshEstimate);
    }
  });
  document.addEventListener('keyup',e=>{if(e.key==='Escape')document.querySelectorAll('.gemlay-gift-upsell__overlay:not([hidden])').forEach(node=>closePicker(node.closest('.gemlay-gift-upsell')));});
  document.addEventListener('click',e=>{if(e.target.closest('.gemlay-pdp .quantity__button'))setTimeout(()=>document.querySelectorAll('.gemlay-gift-upsell[data-context="pdp"]').forEach(refreshEstimate),20);});

  // The paid PDP add-on is handled at document CAPTURE stage so other product
  // form submit listeners cannot render an outdated single-item drawer.
  const showCartError=(root,message)=>{
    const result=root.querySelector('.gemlay-gift-upsell__combined');
    if(result){result.hidden=false;result.textContent=message;result.setAttribute('role','alert');result.style.color='#ab3333';}
  };
  const addWithPackaging=async (event,root,giftId)=>{
    const form=event.target,pdp=form.closest('.gemlay-pdp');
    const submit=form.querySelector('[type="submit"]');
    if(form.dataset.gemlayPackagingBusy==='true')return;
    form.dataset.gemlayPackagingBusy='true';
    if(submit){submit.disabled=true;submit.setAttribute('aria-disabled','true');}
    const path=(window.Shopify?.routes?.root || '/').replace(/\/?$/,'/');
    let productWasAdded=false;
    try{
      const data=new FormData(form);
      const mainId=Number(data.get('id'));
      const qty=Math.max(1,Number(data.get('quantity')||1));
      if(!mainId||!Number.isSafeInteger(mainId))throw new Error('Select a valid jewellery variant.');
      if(!GIFT_IDS.includes(giftId))throw new Error('Select a valid gift box.');
      const choice=root.querySelector('.gemlay-gift-upsell__choice[data-variant-id="'+giftId+'"]');
      if(!choice)throw new Error('Gift box selection was not found.');
      const primary={id:mainId,quantity:qty};
      const props={};
      data.forEach((v,k)=>{if(k.startsWith('properties[')&&k.endsWith(']'))props[k.slice(11,-1)]=String(v);});
      if(Object.keys(props).length)primary.properties=props;
      const plan=data.get('selling_plan');if(plan)primary.selling_plan=Number(plan);
      const payload={items:[primary,{
        id:giftId,quantity:1,properties:{
          'Gift Box Selection':choice.dataset.name||'Gift Box',
          'Packaging Type':'Paid PDP add-on',
          'For Jewellery':pdp.querySelector('h1')?.textContent?.trim()||'Gemlay Jewellery'
        }
      }]};
      const result=await fetch(path+'cart/add.js',{
        method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify(payload)
      });
      const json=await result.json();
      if(!result.ok||json.status)throw new Error(json.description||'Could not add the jewellery and gift box.');
      productWasAdded=true;
      const cartRes=await fetch(path+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!cartRes.ok)throw new Error('Cart could not be verified.');
      const cart=await cartRes.json();
      const paidLine=cart.items.find(x=>Number(x.variant_id)===giftId&&x.properties?.['Packaging Type']==='Paid PDP add-on');
      if(!paidLine)throw new Error('Selected gift box was not found in the cart. Please review your cart.');
      if(!cart.items.some(x=>Number(x.variant_id)===mainId))throw new Error('Jewellery variant was not found in the cart.');
      const actualPrice=Number(paidLine.original_price??paidLine.price);
      if(actualPrice!==Number(choice.dataset.price)){
        throw new Error('Gift-box price could not be verified. Please review the cart.');
      }
      const drawer=document.querySelector('cart-drawer');
      if(drawer&&typeof drawer.renderContents==='function'){
        const sectionsReply=await fetch(path+'cart?sections=cart-drawer,cart-icon-bubble',{credentials:'same-origin',cache:'no-store'});
        if(!sectionsReply.ok)throw new Error('Drawer refresh failed.');
        const sections=await sectionsReply.json();
        if(!sections['cart-drawer']||!sections['cart-icon-bubble'])throw new Error('Cart sections were incomplete.');
        drawer.classList.remove('is-empty');
        drawer.renderContents({id:mainId,sections});
      }else{
        window.location.assign(path+'cart');
      }
      document.dispatchEvent(new CustomEvent('gemlay:cart-changed'));
      // Reset PDP selection after successful addition to avoid unintended duplicates.
      root.dataset.selectedId='';
      root.querySelector('.gemlay-gift-upsell__check').checked=false;
      setSummary(root);
    }catch(err){
      console.error('[Gemlay paid packaging]',err);
      showCartError(root,err.message||'Could not add gift packaging.');
      if(productWasAdded)window.location.assign(path+'cart');
    }finally{
      form.dataset.gemlayPackagingBusy='false';
      if(submit){submit.disabled=false;submit.removeAttribute('aria-disabled');}
    }
  };
  document.addEventListener('submit',event=>{
    const form=event.target;
    if(!form.matches?.('product-form form'))return;
    const pdp=form.closest('.gemlay-pdp');if(!pdp)return;
    const root=pdp.querySelector('.gemlay-gift-upsell[data-context="pdp"]');
    if(!root)return;
    const checked=root.querySelector('.gemlay-gift-upsell__check')?.checked;
    if(!checked)return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const id=Number(root.dataset.selectedId||0);
    if(!GIFT_IDS.includes(id)){
      showCartError(root,'Please choose a gift box or untick gift packaging.');
      openPicker(root);
      return;
    }
    addWithPackaging(event,root,id);
  },true);

})();
